import { render, staticRenderFns } from "./NotFoundTransference.vue?vue&type=template&id=67857cb0&scoped=true"
import script from "./NotFoundTransference.vue?vue&type=script&lang=js"
export * from "./NotFoundTransference.vue?vue&type=script&lang=js"
import style0 from "./NotFoundTransference.vue?vue&type=style&index=0&id=67857cb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67857cb0",
  null
  
)

export default component.exports